var map = {
	"./blind-page.png": 70228,
	"./bookcovers/texture1.png": 33959,
	"./bookcovers/texture1_small.png": 84123,
	"./bookcovers/texture2.png": 31308,
	"./bookcovers/texture2_small.png": 38788,
	"./bookcovers/texture3.png": 83573,
	"./bookcovers/texture3_small.png": 66505,
	"./bookcovers/texture4.png": 43450,
	"./bookcovers/texture4_small.png": 41890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;